import { render, staticRenderFns } from "./CoachRubrics.vue?vue&type=template&id=370a4958"
import script from "./CoachRubrics.vue?vue&type=script&lang=js"
export * from "./CoachRubrics.vue?vue&type=script&lang=js"
import style0 from "./CoachRubrics.vue?vue&type=style&index=0&id=370a4958&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports